import React from "react";

export const SubDone = () => {
  return (
    <>
      <svg
        width="37"
        height="36"
        viewBox="0 0 37 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="18.5" cy="18" r="12" fill="#109EC9" />
        <path
          d="M14.5 17L18.0561 20.8794C18.1155 20.9442 18.2178 20.9442 18.2772 20.8794L25.5 13"
          stroke="#FF6702"
          stroke-width="2"
        />
        <path
          d="M30 18C30 20.2745 29.3255 22.4979 28.0619 24.3891C26.7983 26.2802 25.0022 27.7542 22.9009 28.6246C20.7995 29.495 18.4872 29.7228 16.2565 29.279C14.0257 28.8353 11.9766 27.74 10.3683 26.1317C8.75997 24.5234 7.6647 22.4743 7.22097 20.2435C6.77724 18.0128 7.00498 15.7005 7.87539 13.5991C8.74579 11.4978 10.2198 9.70174 12.1109 8.4381C14.0021 7.17446 16.2255 6.5 18.5 6.5"
          stroke="#044E97"
          stroke-linecap="round"
        />
      </svg>
    </>
  );
};
